module.exports = __webpack_public_path__ + "media/mypage/images/bg_japan-ff2660e6a9c1c46fd9ac2fd74e9f07c6.gif";